<template>
    <div class="cookies-page">
        <div class="cookies-header">
            <div class="cookies-close" @click="close">
                <i class="el-icon-close"></i>
            </div>
        </div>
        <section class="panel">
            <h1 class="title">{{ $t('cookie.child.title') }}</h1>
            <p class="desc">{{ $t('cookie.child.text') }}</p>
            <div class="cookie-dialog-btnTop">{{ $t('cookie.child.btnTop') }}</div>
             <h1 class="title">{{ $t('cookie.child.textBottomTitle') }}</h1>
            <div class="item" v-for="(group, i) in groups" :key="group.key">
                <button class="head" @click="toggle(i)" :aria-expanded="openIndex === i">
                    <!-- <span class="icon" :class="{ open: openIndex === i }">+</span> -->
                    <span class="cookie-dialog-bottom-content-icon">
                        <i class="el-icon-plus" v-if="openIndex !== i"></i>
                        <i class="el-icon-minus" v-else></i>
                    </span>
                    <span class="name">{{ group.name }}</span>
                    <span class="spacer"></span>
                    <span class="chip" v-if="group.always">Always Active</span>
                    <!-- <label v-else class="switch">
                        <input type="checkbox" v-model="group.enabled" />
                        <i></i>
                    </label> -->
                    <label v-else class="switch">
                        <el-switch v-model="group.switchValue" active-color="#64715D" inactive-color="#D9D9D9">
                        </el-switch>
                    </label>
                </button>
                <div class="body" v-show="openIndex === i">
                    <p v-for="(p, idx) in group.paragraphs" :key="idx">{{ p }}</p>
                </div>
            </div>

        </section>
    </div>
</template>
<script>
export default {
    name: 'cookies-mobile',
    data() {
        return {
            openIndex: 0,
            groups: [
                {
                    name: this.$t('cookie.child.groupsList.group1.name'),
                    always: true,
                    enabled: true,
                    paragraphs: [
                        this.$t('cookie.child.groupsList.group1.paragraphs'),
                        this.$t('cookie.child.groupsList.group1.paragraphs1')
                    ],
                    switchValue: false,
                },
                {
                    name: this.$t('cookie.child.groupsList.group2.name'),
                    always: false,
                    enabled: true,
                    paragraphs: [
                        this.$t('cookie.child.groupsList.group2.paragraphs'),
                        this.$t('cookie.child.groupsList.group2.paragraphs1')
                    ],
                    switchValue: false,
                },
                {
                    name: this.$t('cookie.child.groupsList.group3.name'),
                    always: false,
                    enabled: true,
                    paragraphs: [
                        this.$t('cookie.child.groupsList.group3.paragraphs'),
                        this.$t('cookie.child.groupsList.group3.paragraphs1')
                    ],
                    switchValue: false,
                },
                {
                    name: this.$t('cookie.child.groupsList.group4.name'),
                    always: false,
                    enabled: true,
                    paragraphs: [
                        this.$t('cookie.child.groupsList.group4.paragraphs')
                    ],
                    switchValue: false,
                }
            ]
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        toggle(idx) {
            this.openIndex = this.openIndex === idx ? -1 : idx;
        },
        save() {
            alert('已保存Cookie偏好设置');
        },
        enableAll() {
            this.groups = this.groups.map(g => ({ ...g, enabled: true }));
        }
    }
}
</script>
<style scoped>
.cookies-header {
    width: 100%;
}

.cookies-close {
    font-size: 5vw;
    text-align: right;
}

.cookies-page {
    width: 100%;
    background: #F8F9FC;
    padding: 12px;
}

.panel {
    border-radius: 10px;
    /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06); */
    padding: 14px;
}

.title {
    margin: 0 0 6px;
    font-weight: 800;
    font-size: 5vw;
}

.desc {
    margin: 0 0 10px;
    color: #5e6b63;
    line-height: 1.6;
    font-size: 3vw;
}

.cookie-dialog-btnTop {
    background-color: #1e1e1e;
    border-color: #1e1e1e;
    padding: 2% 3%;
    font-size: 3vw;
    border-radius: 10px;
    color: #fff;
    width: 20vw;
    cursor: pointer;
    text-align: center;
    margin: 5vw 0;
}

.item {
    border: 1px solid #e5ebe4;
    overflow: hidden;
}

.item:nth-child(5) {
    border-radius: 8px 8px 0px 0px;
}

.item:nth-child(8) {
    border-radius: 0px 0px 8px 8px;
}

.head {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #E7EAE2;
    border: 0;
    padding: 10px;
    cursor: pointer;
}

/* .icon {
    width: 5vw;
    height: 5vw;
    border-radius: 4px;
    display: inline-grid;
    place-items: center;
    background: #e6eee3;
    color: #2f3b34;
    font-weight: 900;
    transform: rotate(0deg);
    transition: transform .2s ease;
}

.icon.open {
    transform: rotate(45deg);
} */
.cookie-dialog-bottom-content-icon {
    border-radius: 4px;
    display: inline-grid;
    place-items: center;
    color: #2f3b34;
    font-size: 0.8vw;
}

.cookie-dialog-bottom-content-icon.open {
    transform: rotate(45deg);
}

.name {
    font-weight: 700;
    color: #29352d;
}

.spacer {
    flex: 1;
}

.chip {
    /* background: #e9f3e8; */
    color: #2f3b34;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
}

.body {
    background: #fff;
    padding: 10px;
    color: #3a463f;
    line-height: 1.6;
}

.body p {
    margin: 0 0 8px;
}



@media (min-width: 768px) {
    .cookies-page {
        padding: 24px;
    }

    .panel {
        max-width: 560px;
        margin: 0 auto;
    }
}
</style>
